import { useBackend } from "../../services";

export const useGetPasskeys = () => {
  const { get } = useBackend();
  const getPasskeys = () => get("passkeys");
  return { getPasskeys };
};

export interface IPasskey {
  id: string;
  createdUnixTimestamp: string;
}
